import { showCustomToast } from 'common/components/CustomToast/utils';
import { useMutation } from '@apollo/client';
import React from 'react';

import {
  MessagePurchaseOrderCreate,
  MessagePurchaseOrderCreateVariables,
} from './__generated__/MessagePurchaseOrderCreate';
import { PivotKeys } from 'common/components/MessagesSections';
import {
  CreateMessageData,
  CreateNewMessage,
} from 'common/components/CreateNewMessage';
import { Stack } from '@fluentui/react';

import MESSAGE_PURCHASE_ORDER_CREATE from './MessagePurchaseOrderCreate.graphql';
import PURCHASE_ORDER_MESSAGE from '../PurchaseOrderMessage.graphql';

interface NewMessageProps {
  purchaseOrderId: string;
  selectedKey: string;
  onCreateMessage: () => void;
  dirty?: boolean;
}

export const NewMessage: React.FC<NewMessageProps> = ({
  purchaseOrderId,
  selectedKey,
  onCreateMessage,
  dirty,
}) => {
  const [createMessage, { loading }] = useMutation<
    MessagePurchaseOrderCreate,
    MessagePurchaseOrderCreateVariables
  >(MESSAGE_PURCHASE_ORDER_CREATE);

  const messageFilter =
    selectedKey === PivotKeys.sent
      ? { _isOutgoingMessage: { equalTo: true } }
      : { _isIncomingMessage: { equalTo: true } };

  const onSubmit = async (formData: CreateMessageData) => {
    const { messageComment, reminderDates, isResponseRequired, receivers } = {
      ...formData,
    };
    const { communicationChannel, department, user } = { ...receivers };
    const { errors } = await createMessage({
      variables: {
        input: {
          entityId: purchaseOrderId,
          message: { messageComment, reminderDates, isResponseRequired },
          communicationChannel,
          department,
          user,
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: PURCHASE_ORDER_MESSAGE,
          variables: {
            id: purchaseOrderId,
            first: 10,
            filter: messageFilter,
          },
        },
      ],
    });

    if (!errors) {
      onCreateMessage();
      showCustomToast({
        content: 'Message sent successfully.',
        appearance: 'success',
      });
    } else
      showCustomToast({
        content: `${errors[0].message}`,
        appearance: 'error',
      });
  };

  return (
    <Stack tokens={{ padding: '0px 10px 0px 0px' }}>
      <CreateNewMessage onSubmit={onSubmit} loading={loading} dirty={dirty} />
    </Stack>
  );
};
